import './DodProductFilterPreview.scss';
import React, {memo, useMemo} from 'react';
import {DodFilters} from '@/types/DodRun';
import {ByzzerChangeEventHandler} from '@byzzer/ui-components';
import {DodFilterPreview, DodFilterPreviewProps} from '@/components/DodConfigEditor/common';
import classnames from 'classnames';
import { DodSavedSelectionTypes } from '@/components/DodConfigEditor/types';
import { productsInitialGroups } from '@/components/DodConfigEditor/common/utils';

const baseClassName = 'dod-product-filter-preview';

export type DodProductFilterPreviewProps = {
    value: DodFilters;
    onChange?: ByzzerChangeEventHandler<DodFilters>;
} & Partial<DodFilterPreviewProps>;

const savedSelectionDescription = <>
    <p>This will save the full set of selections currently in your Selection panel so that you can easily reuse them in future extracts.</p>
    <p>Your saved selections will be available in the "My Saved Products" folder on the left.</p>
</>;

export const DodProductFilterPreview = memo(({ className, ...props }: DodProductFilterPreviewProps) => {

    const count = useMemo<number>(() => {
        const { value } = props;
        let count = 0;

        for (let key in value) {
            if (key === 'markets' || key === 'timePeriods') continue;

            if (key === 'characteristics' || key === 'customCharacteristics' || key === 'ppgs') {
                const length = Object.keys(value[key] || {}).length;
                if (length > 0) {
                    count += length;
                }
            } else {
                const filterItem = value[key];
                if (filterItem && filterItem.values && filterItem.summedSelections) {
                    if (filterItem.values.length > 0 || filterItem.summedSelections.length > 0) {
                        count++;
                    }
                }
            }
        }
        return count;
    }, [props.value]);

    return (
        <DodFilterPreview
            {...props}
            className={classnames(baseClassName, className)}
            savedSelectionType={DodSavedSelectionTypes.PRODUCT}
            initialGroups={productsInitialGroups}
            emptyStateContent={'No Products Selected'}
            title={count > 0 ? `${count} Selected` : ''}
            selectionCount={count}
            savedSelectionDescription={savedSelectionDescription}
        />
    );
});

export default DodProductFilterPreview;
